// extracted by mini-css-extract-plugin
export default {"module-tile":"menu_module-tile__IEMyR","selected":"menu_selected__kRXNp","open":"menu_open__QKu-f","menu-container":"menu_menu-container__DFkdL"};